import React from 'react'
import { useTheme } from '@mui/material'
import Box from '@mui/material/Box'

const CustomHomeDivider = () => {
  const theme = useTheme()

  const wrapperStyle = {
    width: '100%',
    height: '4px',
    position: 'relative',
    background: theme.palette.violetsAreBlue,
  }

  const startStyle = {
    position: 'absolute',
    top: '-6px',
    left: '0px',
    width: '16px',
    height: '16px',
    background: theme.palette.violetsAreBlue,
    rotate: '45deg',
  }

  const endStyle = {
    position: 'absolute',
    top: '-6px',
    right: '0px',
    width: '16px',
    height: '16px',
    background: theme.palette.violetsAreBlue,
    rotate: '45deg',
  }

  return (
    <Box sx={wrapperStyle}>
      <Box sx={startStyle}></Box>
      <Box sx={endStyle}></Box>
    </Box>
  )
}

export default CustomHomeDivider